import { Fragment, ReactElement } from "react";
import { IntlProvider } from "react-intl";
import ReactAppContainer from "../ReactAppContainer";
import { VueContextType } from "../vueContext";
import { HeroBasic } from "./hero-basic";

export default function HeroProviderBasic(props: VueContextType): ReactElement {
  return (
    <ReactAppContainer vueProps={props}>
      <IntlProvider
        locale={props.locale}
        messages={props.messages[props.locale]}
        textComponent={Fragment}
      >
        <HeroBasic />
      </IntlProvider>
    </ReactAppContainer>
  );
}
